import {
    B2B_DOMAIN_DEV,
    B2B_DOMAIN_PRODUCTION,
    B2B_DOMAIN_SANDBOX,
    B2B_DOMAIN_TEST,
    B2B_DOMAIN_YASTORE,
} from '../../const';

export const getMasterDomain = (host: string): string => {
    if (host.includes(B2B_DOMAIN_DEV)) {
        return B2B_DOMAIN_DEV;
    }

    if (host.includes(B2B_DOMAIN_TEST)) {
        return B2B_DOMAIN_TEST;
    }

    if (host.includes(B2B_DOMAIN_SANDBOX)) {
        return B2B_DOMAIN_SANDBOX;
    }

    if (host.includes(B2B_DOMAIN_YASTORE)) {
        return B2B_DOMAIN_YASTORE;
    }

    if (host.includes(B2B_DOMAIN_PRODUCTION)) {
        return B2B_DOMAIN_PRODUCTION;
    }

    // localhost, pr-%%%%.b2b.beta.yastore.yandex.ru, yastore.yandex.ru:9000
    return host;
};
